import React from 'react';
import PropTypes from 'prop-types';

import { cn } from '../../utils/classnames';

const variants = {
  primary: 'bg-clubbie-blue text-black hover:opacity-90',
  secondary:
    'bg-transparent border border-light-blue text-light-blue hover:bg-blue-shade-7',
  danger: 'bg-red-500 text-[#FEFCEB] hover:bg-red-600',
  ghost: 'bg-transparent text-light-blue hover:bg-blue-shade-7',
};

const sizes = {
  sm: 'px-3 py-1.5 text-sm',
  md: 'px-4 py-2 text-base',
  lg: 'px-6 py-3 text-lg',
};

export const Button = ({
  children,
  variant = 'primary',
  size = 'md',
  isLoading = false,
  disabled = false,
  className,
  ...props
}) => {
  return (
    <button
      className={cn(
        'rounded-clubbie font-medium transition-all duration-200',
        'disabled:opacity-50 disabled:cursor-not-allowed',
        'focus:outline-none focus:ring-2 focus:ring-clubbie-blue focus:ring-offset-2',
        variants[variant],
        sizes[size],
        className,
      )}
      disabled={disabled || isLoading}
      {...props}
    >
      {isLoading && (
        <span className="inline-block animate-spin mr-2" aria-hidden="true">
          ⏳
        </span>
      )}
      {children}
    </button>
  );
};

Button.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['primary', 'secondary', 'danger', 'ghost']),
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  isLoading: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

export default Button;
